import type { SessionSlice } from '@/shared/lib/zustand-types';

export type RoomLobbySlice = {
  roomCode: string | null;
  lobbyError: string | null;
  lobbyBusy: boolean;

  setRoomCode: (code: string | null) => void;
  setLobbyError: (error: string | null) => void;
  setLobbyBusy: (busy: boolean) => void;
  resetLobby: () => void;
};

export const createRoomLobbySlice: SessionSlice<RoomLobbySlice> = (set) => ({
  roomCode: null,
  lobbyError: null,
  lobbyBusy: false,

  setRoomCode: (code) =>
    set((s) => {
      s.roomCode = code;
    }),
  setLobbyError: (error) =>
    set((s) => {
      s.lobbyError = error;
    }),
  setLobbyBusy: (busy) =>
    set((s) => {
      s.lobbyBusy = busy;
    }),
  resetLobby: () =>
    set((s) => {
      s.roomCode = null;
      s.lobbyError = null;
      s.lobbyBusy = false;
    }),
});
